import { useApi } from './api';

export const useStandings = (seasonArg, type = 'total') =>
  useApi(`standings/${type}?season=${seasonArg}`);
